import React from "react";
import RsvpForm from "../components/rsvp-form";
import Countdown from "../components/countdown";
import Photos from "../components/photos";
import Container from 'react-bootstrap/Container';
import 'photoswipe/style.css';


const Home = () => {
    return (
        <>
            <div className="title d-flex justify-content-center">
                <h1>Terese and Lizzy</h1>
            </div>
            <div className="countdown d-flex justify-content-center mb-5">
                <Countdown></Countdown>
            </div>
            <div className="countdown dresscode card d-flex flex-column justify-content-center align-items-center">
               <h3>Dress Code</h3>
                <p>There's no real dress code, but anything from Semi-formal to formal is good.</p>
            </div>
            <div className="photo-layer">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100"><g fill="#FCF8EF"><path d="M0 0v99.7C62 69 122.4 48.7 205 66c83.8 17.6 160.5 20.4 240-12 54-22 110-26 173-10a392.2 392.2 0 0 0 222-5c55-17 110.3-36.9 160-27.2V0H0Z" opacity=".5"></path><path d="M0 0v74.7C62 44 122.4 28.7 205 46c83.8 17.6 160.5 25.4 240-7 54-22 110-21 173-5 76.5 19.4 146.5 23.3 222 0 55-17 110.3-31.9 160-22.2V0H0Z"></path></g></svg>
                <div class="photos d-flex justify-content-center">
                    <div class="photo-container">
                        <Photos></Photos>
                    </div>
                </div>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100"><g fill="#bcd786"><path d="M0 0v99.7C62 69 122.4 48.7 205 66c83.8 17.6 160.5 20.4 240-12 54-22 110-26 173-10a392.2 392.2 0 0 0 222-5c55-17 110.3-36.9 160-27.2V0H0Z" opacity=".5"></path><path d="M0 0v74.7C62 44 122.4 28.7 205 46c83.8 17.6 160.5 25.4 240-7 54-22 110-21 173-5 76.5 19.4 146.5 23.3 222 0 55-17 110.3-31.9 160-22.2V0H0Z"></path></g></svg>
            <Container className="rsvp-home container d-flex align-items-center flex-column">
                <h2>RSVP</h2>
                <div className="form-container">
                    <RsvpForm></RsvpForm>
                </div>
            </Container>
        </>
            
            
    )
};

export default Home;